
export interface Product {
  id: string;
  name: string;
  price: number;
  image: string;
  category: string;
  description: string;
  hairType?: string[];
  skinType?: string[];
  featured?: boolean;
  rating?: number;
  reviews?: number;
  ingredients?: string;
  type?: string;
}

export const products: Product[] = [
  {
    id: "curl-defining-cream",
    name: "Curl Defining Cream",
    price: 24.99,
    image: "/lovable-uploads/2fd46292-ba1d-497b-99ae-02662e63aa8e.webp",
    category: "Hair Care",
    description: "Define and enhance natural curls with our lightweight, moisture-rich cream.",
    hairType: ["Curly", "Coily"],
    featured: true,
    rating: 4.7,
    reviews: 124,
    type: "Styling Cream",
    ingredients: "Aqua, Aloe Barbadensis Leaf Juice, Cetearyl Alcohol, Cocos Nucifera Oil, Butyrospermum Parkii Butter, Glycerin"
  },
  {
    id: "revitalizing-facial-serum",
    name: "Revitalizing Facial Serum",
    price: 34.99,
    image: "/lovable-uploads/f2e7f77e-243c-40cc-b6e5-60535abc7548.webp",
    category: "Skin Care",
    description: "Revitalize and rejuvenate your skin with our nourishing facial serum.",
    skinType: ["All", "Dry", "Combination"],
    featured: true,
    rating: 4.9,
    reviews: 92,
    type: "Facial Serum",
    ingredients: "Aqua, Glycerin, Niacinamide, Panthenol, Hyaluronic Acid, Tocopherol, Aloe Barbadensis Leaf Extract"
  },
  {
    id: "purifying-face-mask",
    name: "Purifying Face Mask",
    price: 26.99,
    image: "/lovable-uploads/032ce02d-a3d0-4601-806f-906f2f4c6760.webp",
    category: "Skin Care",
    description: "Deep cleansing mask that draws out impurities for a clear, radiant complexion.",
    skinType: ["All", "Oily", "Combination"],
    featured: true,
    rating: 4.8,
    reviews: 67,
    type: "Treatment",
    ingredients: "Kaolin Clay, Bentonite Clay, Charcoal Powder, Aloe Barbadensis Leaf Juice, Glycerin, Avocado Oil"
  },
  {
    id: "soothing-facial-oil",
    name: "Soothing Facial Oil",
    price: 36.99,
    image: "/lovable-uploads/a03b2a4b-938c-49a8-906a-28f57964cc46.webp",
    category: "Skin Care",
    description: "Nourishing facial oil that provides a natural, dewy glow and soothes irritation.",
    skinType: ["All", "Dry"],
    featured: true,
    rating: 4.8,
    reviews: 92,
    type: "Facial Oil",
    ingredients: "Squalane, Rosa Canina Fruit Oil, Argania Spinosa Kernel Oil, Tocopherol, Lavandula Angustifolia Oil"
  },
  {
    id: "leave-in-treatment",
    name: "Leave-In Treatment",
    price: 22.99,
    image: "/lovable-uploads/50f0e165-c6f5-4211-8de4-4a9a99473306.webp",
    category: "Hair Care",
    description: "Lightweight leave-in treatment for daily moisture and protection.",
    hairType: ["All", "Dry", "Curly"],
    featured: false,
    rating: 4.6,
    reviews: 43,
    type: "Treatment",
    ingredients: "Aqua, Cetearyl Alcohol, Behentrimonium Methosulfate, Panthenol, Glycerin, Cocos Nucifera Oil"
  },
  {
    id: "purifying-face-cream",
    name: "Purifying Face Cream",
    price: 29.99,
    image: "/lovable-uploads/3638dba5-730a-469e-b0f0-ef41fb0d912e.webp",
    category: "Skin Care",
    description: "Gentle daily moisturizer that nourishes skin without clogging pores.",
    skinType: ["All", "Sensitive"],
    featured: false,
    rating: 4.7,
    reviews: 58,
    type: "Moisturizer",
    ingredients: "Aqua, Glycerin, Coco-Glucoside, Aloe Barbadensis Leaf Juice, Panthenol, Chamomilla Recutita Flower Extract"
  }
];
